import { render, staticRenderFns } from "./AiAssistantWidget.vue?vue&type=template&id=38133850&scoped=true&"
import script from "./AiAssistantWidget.vue?vue&type=script&lang=js&"
export * from "./AiAssistantWidget.vue?vue&type=script&lang=js&"
import style0 from "./AiAssistantWidget.vue?vue&type=style&index=0&id=38133850&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38133850",
  null
  
)

export default component.exports